<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<a id="page07">
<p class="dedicationTextcenter"><span class="bold">For Teresa Johnson,<br/> who tamed the Dragon</span></p>
</a><a id="page08">
</a></div>
<a id="page08">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// icemaidenthe_ded01.vue?39a8cf21